import React, { useState } from 'react'
import ReactTable from 'react-table'
import { Link } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import { Modal, DatePicker } from 'antd'
import moment from 'moment'
import {
  Div, Button, Icon, Input, H3, DynamicButtonLink, Loading,
} from 'konsys-ui'
import axios from 'axios'
import { theme } from '../../../styles/_variables'
import { Wrapper, ModalCancel } from '../../../components/purchase-order-components'
import { PURCHASEORDERS } from '../../../constants/graph/query'
import { ListContainer, Select } from '../../../components/common'
import { PAYMENT_TYPE } from '../constants'
import './style-css.css'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import PERMISSION from '../../../constants/permissions'
import config from './config'

const { color } = theme

const Index = () => {
  const [isLoading, setIsLoading] = useState()
  const [monthReportModal, setMonthReportModal] = useState(false)
  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>รายการใบสั่งซื้อ</H3>
        <Div display='flex' flexDirection='row' justifyContent='space-between'>
          <DynamicButtonLink link='/purchase-order/add' condition={_.includes(window.perms, PERMISSION.CREATE_PURCHASE_ORDER)} props={{ text: 'สร้างใบสั่งซื้อ' }} />
        </Div>
      </Div>
      <List />
    </Div>
  )
}

export const List = () => {
  const [current, setCurrent] = useState(0)
  const [variable, setVariable] = useState({})
  const [cancelModal, setCancelModal] = useState(false)
  const [deleteId, setDeleteId] = useState(0)
  const {
    data, loading, error, fetchMore, refetch,
  } = useQuery(PURCHASEORDERS, {
    variables: {
      ...variable,
      limit: 5,
      offset: 5 * current,
      orderField: 'updatedAt',
      orderBy: 'DESC',
    },
  })

  return (
    <Wrapper overflow padding='0 0 40px 0'>
      {loading && _.isEmpty(data) && <Loading center='true' />}
      {(!loading || !_.isEmpty(data))
        && <Div>
          <ReactTable
            className='table'
            data={data.PurchaseOrderList.lists} // *
            resizable={false}
            columns={config.columns({
              refetch,
              setCancelModal,
              setDeleteId,
            })} // *
            minRows={5}
            manual
            // defaultPageSize={10}
            showPageSizeOptions={false}
            getTdProps={() => ({ disabled: true })} // *
            getTrProps={(state, rowInfo) => { // *
              if (rowInfo) {
                return {
                  style: {
                    padding: '8px 0',
                    backgroundColor: '#ffffff',
                    borderLeft: `3px solid ${color.primaryColor}`,
                  },
                }
              } return {}
            }}
            previousText='ก่อนหน้า'
            nextText='ถัดไป'
            pageText='หน้า'
            ofText='จาก'
            page={current}
            pages={Math.ceil(data.PurchaseOrderList.totalFilter / 5)}
            onPageChange={page => setCurrent(page)}
            onFilteredChange={async (newFiltered) => {
              const newOjb = {
                status: 'ALL',
                number: '',
                Supplier: { name: '' },
              }
              await newFiltered.forEach((v) => {
                if (v.id === 'Supplier.name') {
                  Object.assign(newOjb, { Supplier: { name: v.value } })
                } else if (v.id === 'Driver.fullname') {
                  Object.assign(newOjb, { fullname: v.value })
                } else {
                  Object.assign(newOjb, { [v.id]: v.value })
                }
              })
              setCurrent(0)
              refetch(newOjb)
              setVariable(newOjb)
            }}
            onSortedChange={async (newSorted) => {
              setCurrent(0)
              refetch({
                orderBy: newSorted[0].desc ? 'DESC' : 'ASC',
                orderField: newSorted[0].id,
              })
            }}
          />
          {
            loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
          }
          <ModalCancel deleteId={deleteId} refetchQuery={refetch} cancelModal={cancelModal} setCancelModal={setCancelModal}/>
        </Div>
      }
    </Wrapper>
  )
}

export default Index
